import React from "react";
import { useState, useEffect, useRef } from "react";

function Question({
  data,
  onAnswerUpdate,
  numberOfQuestions,
  activeQuestion,
  setActiveQuestion,
  onSetStep,
}) {
  const [selected, setSelected] = useState("");
  const [error, setError] = useState("");
  const radiosWrapper = useRef();

  useEffect(() => {
    const findCheckedInput =
      radiosWrapper.current.querySelector("input:checked");
    if (findCheckedInput) {
      findCheckedInput.checked = false;
    }
  }, [data]);

  function changeHandler(e) {
    setSelected(e.target.value);
    if (error) {
      setError("");
    }
  }

  function nextClickHandler(e) {
    if (selected === "") {
      return setError("Please Select One Option");
    }
    onAnswerUpdate((prevState) => [
      ...prevState,
      { q: data.question, a: selected, options:data.options },
    ]);
    setSelected("");

    if (activeQuestion < numberOfQuestions - 1) {
      setActiveQuestion(activeQuestion + 1);
      console.log(activeQuestion);
    } else {
      console.log("time stop");
      onSetStep(3);
    }
  }

  return (
    <div className="card">
      <div className="card-content">
        <div className="content">
          <h2 className="mb-5"> {data.question} </h2>
          <div className="control" ref={radiosWrapper}>
            {data.options.map((choice, i) => (
              <label className="radio has-background-light" key={i + 1}>
                <input
                  type="radio"
                  name="answer"
                  value={i+1}
                  onChange={changeHandler}
                />
                {choice}
              </label>
            ))}
          </div>
          {error && <div className="has-text-danger">{error}</div>}
          <button
            className="button is-link is-medium is-fullwidth mt-4"
            onClick={nextClickHandler}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Question;
